import { makeStyles } from '@material-ui/core/styles';

import { RiCloseLine, RiRobot2Line } from '@remixicon/react';

import { Text } from '@backstage/ui';

import {
  ChatEventNotificationFragment,
  getTypeOrNull,
} from '@spotify/confidence-graphql';

import { useSubagentPanel } from '../ChatThread/SubagentPanelContext';

const useStyles = makeStyles({
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  root: {
    animation: '$fadeIn 500ms ease-in',
    display: 'flex',
    flexDirection: 'column',
  },
  headerStatic: {
    alignItems: 'center',
    display: 'flex',
    gap: 'var(--bui-space-2)',
    padding: 'var(--bui-space-1) 0',
  },
  icon: {
    color: 'var(--bui-fg-secondary)',
    flexShrink: 0,
  },
  failureIcon: {
    color: 'var(--bui-fg-danger)',
    flexShrink: 0,
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: 'var(--bui-fg-secondary)',
      textUnderlineOffset: '2px',
    },
  },
});

type NotificationMessageProps = {
  notification: ChatEventNotificationFragment;
};

export const NotificationMessage = ({
  notification,
}: NotificationMessageProps) => {
  const classes = useStyles();
  const panel = useSubagentPanel();
  const stopped = notification.childChatStopped;
  if (!stopped) return null;

  const childChat = getTypeOrNull(stopped.childChat);
  const success = stopped.success ?? true;

  const childTitle = childChat?.displayName ?? 'Subagent';
  const statusLabel = success ? 'finished' : 'failed';

  const label = (
    <Text variant="body-small" color="secondary">
      {childChat && panel ? (
        <span
          className={classes.link}
          role="button"
          tabIndex={0}
          onClick={e => {
            e.stopPropagation();
            panel.openSubagentPanel(childChat.name);
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              panel.openSubagentPanel(childChat.name);
            }
          }}
        >
          {childTitle}
        </span>
      ) : (
        childTitle
      )}
      {` ${statusLabel}`}
    </Text>
  );

  return (
    <div className={classes.root}>
      <div className={classes.headerStatic}>
        <RiRobot2Line size={14} className={classes.icon} />
        {!success && <RiCloseLine size={14} className={classes.failureIcon} />}
        {label}
      </div>
    </div>
  );
};
